import React from 'react';
import useFormStateWithErrors from '@gr-monorepo/common/utils/useFormStateWithErrors';

export const defaultValue = {
  fio: '',
  workplacePosition: '',
  phone: '',
  email: '',
  text: '',
};

const defaultErrors = {
  fio: null,
  workplacePosition: null,
  phone: null,
  email: null,
  text: null,
};

const useFeedbackState = () => {
  return useFormStateWithErrors(defaultValue, defaultErrors);
};

export default useFeedbackState;

export type FeedbackState = ReturnType<typeof useFeedbackState>;
